import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from './PluginGeneratedSerialDescriptor.mjs';
import { contentEqualsaf55p28mnw74 as contentEquals } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from './PluginHelperInterfaces.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function InlinePrimitiveDescriptor(name, primitiveSerializer) {
  return new (InlineClassDescriptor())(name, new (InlinePrimitiveDescriptor$1())(primitiveSerializer));
}
var InlineClassDescriptorClass;
function InlineClassDescriptor() {
  if (InlineClassDescriptorClass === VOID) {
    class $ extends PluginGeneratedSerialDescriptor() {
      constructor(name, generatedSerializer) {
        super(name, generatedSerializer, 1);
        this.w1z_1 = true;
      }
      u1p() {
        return this.w1z_1;
      }
      hashCode() {
        return imul(super.hashCode(), 31);
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.serialization.internal.equalsImpl' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_5;
          }
          if (!(other instanceof InlineClassDescriptor())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.a1o() === other.a1o())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(other.w1z_1 && contentEquals(this.h1z(), other.h1z()))) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.v1p() === other.v1p())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          var inductionVariable = 0;
          var last = this.v1p();
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (!(this.a1q(index).a1o() === other.a1q(index).a1o())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
              if (!equals(this.a1q(index).t1p(), other.a1q(index).t1p())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
            }
             while (inductionVariable < last);
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'InlineClassDescriptor');
    InlineClassDescriptorClass = $;
  }
  return InlineClassDescriptorClass;
}
var InlinePrimitiveDescriptor$1Class;
function InlinePrimitiveDescriptor$1() {
  if (InlinePrimitiveDescriptor$1Class === VOID) {
    class $ {
      constructor($primitiveSerializer) {
        this.x1z_1 = $primitiveSerializer;
      }
      y1z() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.x1z_1];
      }
      x1m() {
        var message = 'unsupported';
        throw IllegalStateException().o(toString(message));
      }
      y1m(encoder, value) {
        // Inline function 'kotlin.error' call
        var message = 'unsupported';
        throw IllegalStateException().o(toString(message));
      }
      z1m(decoder) {
        // Inline function 'kotlin.error' call
        var message = 'unsupported';
        throw IllegalStateException().o(toString(message));
      }
    }
    protoOf($).z1z = typeParametersSerializers;
    initMetadataForClass($, VOID, VOID, VOID, [GeneratedSerializer()]);
    InlinePrimitiveDescriptor$1Class = $;
  }
  return InlinePrimitiveDescriptor$1Class;
}
//region block: exports
export {
  InlinePrimitiveDescriptor as InlinePrimitiveDescriptor3i6ccn1a4fw94,
};
//endregion

//# sourceMappingURL=InlineClassDescriptor.mjs.map
